/* global wpApiSettings */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { wpBase } from "../api/base";

// GET VENDORS/RECIPIENT ID
const fetchRecipientId = createAsyncThunk(
  "vendor/fetchRecipientId",
  async ({ vendorId }, { rejectWithValue }) => {
    if (!vendorId) {
      console.error("vendorId parameter is missing");
      return rejectWithValue("vendorId parameter is missing");
    }

    try {
      const response = await wpBase.get(
        `/wp-json/fz-details/v1/get-recipient-id/${vendorId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error(
        "Error fetching recipient ID:",
        error.response ? error.response.data : error.message
      );
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// GET FORM DATA ID
const fetchFormId = createAsyncThunk(
  "vendor/fetchFormId",
  async (_, { rejectWithValue }) => {
    try {
      const response = await wpBase.get("/listings", {
        headers: {
          "Content-Type": "text/html",
        },
      });

      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, "text/html");
      const inputElement = doc.querySelector('input[type="hidden"]#messageId');

      if (inputElement) {
        const messageIdValue = inputElement.getAttribute("value");
        return messageIdValue;
      } else {
        console.error("Element with ID messageId not found");
        return rejectWithValue("Element with ID messageId not found");
      }
    } catch (error) {
      console.error("Error fetching the URL:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// DELETE UPLOADED IMAGE
const deleteImg = createAsyncThunk(
  "vendor/deleteImg",
  async ({ imgId }, { rejectWithValue }) => {
    if (!imgId) {
      console.error("id parameter is missing");
      return rejectWithValue("id parameter is missing");
    }

    try {
      const response = await wpBase.delete(
        `/wp-json/hivepress/v1/attachments/${imgId}/`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error deleting Image:",
        error.response ? error.response.data : error.message
      );
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export { fetchRecipientId, fetchFormId, deleteImg };
